import { useLazyQuery, useMutation } from "@apollo/client/react";
import { gql } from "@apollo/client";
import toast from "react-hot-toast";
import {  PmStore } from "@/state";




const queryTenantFinacialAccount = gql`
  query tenantFinancialAccount($organizationId: UUID!, $accountId: UUID!) {
    tenantFinancialAccount(organizationId: $organizationId, accountId: $accountId) {
      id
      availableBalanceInDollar
      balanceInDollars
      name
    }
  }
`;



const queryFinancialAccount = gql`
  query financialAccount($organizationId: UUID!, $financialAccountId: UUID!) {
    financialAccount(organizationId: $organizationId, financialAccountId: $financialAccountId) {
      id  
      availableBalanceInDollar
      balanceInDollars
      name
    }
  }
`;



const queryFinancialAccountTransactions = gql`
   query financialAccountTransactions($organizationId: UUID!, $financialAccountId: UUID!, $start: DateTime!, $end: DateTime! ) {
    financialAccountTransactions(organizationId: $organizationId, financialAccountId: $financialAccountId, start: $start, end: $end) {
        id
        amount_in_dollars
        description
        destination_account_id
        source_account_id
        transaction_status
        transaction_type
        source_account_id
        created_ts
        reference_id
    }
  }
`;


const queryTenantFinacialAccounts = gql`
  query tenantFinancialAccounts($organizationId: UUID!, $accountId: UUID!) {
    tenantFinancialAccounts(organizationId: $organizationId, accountId: $accountId) {
      id
      availableBalanceInDollar
      balanceInDollars
      name
      account_type
      account_type_string
      payment_system
      payment_system_string
      resource_id
    }
  }
`;



const queryApplicationFinacialAccount = gql`
  query applicationFinancialAccount($organizationId: UUID!, $applicationId: UUID!) {
    applicationFinancialAccount(organizationId: $organizationId, applicationId: $applicationId) {
      id
      availableBalanceInDollar
      balanceInDollars
      name
      account_type
      account_type_string
      payment_system
      payment_system_string
    }
  }
`;




const queryOrganizationFinacialAccounts = gql`
  query organizationFinancialAccounts($organizationId: UUID!) {
    organizationFinancialAccounts(organizationId: $organizationId) {
      id
      availableBalanceInDollar
      balanceInDollars
      name
      account_type
      account_type_string
      payment_system
      payment_system_string
      resource_id
    }
  }
`;


const queryPaymentConfig = gql`
  query paymentConfig($organizationId: UUID!) { 
    paymentConfig(organizationId: $organizationId){
        is_cc_enabled
        cc_payment_system_id
        cc_payment_system
        
        is_ach_enabled
        ach_payment_system_id
        ach_payment_system
        org_bank_account_payment_system_account_id
        
        is_back_house_enabled
    }
 }
`;



const queryApplicationTransfers = gql`
  query applicationTransfers($organizationId: UUID!, $applicationId: UUID!) {
    applicationTransfers(organizationId: $organizationId, applicationId: $applicationId) {
      transfer_id
      status
      status_text
      payment_reason
      payment_reason_text
        
      comment
      application_id
      amount_total_dollars
      amount_requested_dollars
      amount_processing_fee_dollars
      amount_platform_fee_dollars
      created_ts
    }
  }
`;


const queryTransfersInProgress = gql`
  query transfersInProgress($organizationId: UUID!) {
    transfersInProgress(organizationId: $organizationId) {
      transfer_id
      status
      status_text
      payment_reason
      payment_reason_text

      comment
      application_id
      amount_total_dollars
      amount_requested_dollars
      amount_processing_fee_dollars
      amount_platform_fee_dollars
      created_ts
      initiated_by
      application_id_friendly
    }
  }
`;





const queryLegalEntityVirtualOpsFinacialAccount = gql`
  query legalEntityVirtualOperationalFinancialAccount($organizationId: UUID!, $legalEntityId: UUID!) {
    legalEntityVirtualOperationalFinancialAccount(organizationId: $organizationId, legalEntityId:$legalEntityId) {
      id
      availableBalanceInDollar
      balanceInDollars
      name
      account_type
      account_type_string
      payment_system
      payment_system_string
      resource_id
    }
  }
`;





const queryLegalEntityVirtualSalesTaxFinacialAccount = gql`
  query legalEntityVirtualSalesTaxFinancialAccount($organizationId: UUID!, $legalEntityId: UUID!) {
    legalEntityVirtualSalesTaxFinancialAccount(organizationId: $organizationId, legalEntityId:$legalEntityId) {
      id
      availableBalanceInDollar
      balanceInDollars
      name
      account_type
      account_type_string
      payment_system
      payment_system_string
      resource_id
    }
  }
`;



const queryLegalEntityVirtualDepositFinacialAccount = gql`
  query legalEntityVirtualDepositFinancialAccount($organizationId: UUID!, $legalEntityId: UUID!) {
    legalEntityVirtualDepositFinancialAccount(organizationId: $organizationId, legalEntityId:$legalEntityId) {
      id
      availableBalanceInDollar
      balanceInDollars
      name
      account_type
      account_type_string
      payment_system
      payment_system_string
      resource_id
    }
  }
`;


const queryLegalEntityFinacialAccounts = gql`
  query legalEntityFinancialAccounts($organizationId: UUID!, $legalEntityId: UUID!) {
    legalEntityFinancialAccounts(organizationId: $organizationId, legalEntityId: $legalEntityId) {
      id
      availableBalanceInDollar
      balanceInDollars
      name
      account_type
      account_type_string
      payment_system
      payment_system_string
      resource_id
    }
  }
`;


const queryPlatformFeeFinacialAccount = gql`
  query platformFeeFinancialAccount($organizationId: UUID!) {
    platformFeeFinancialAccount(organizationId: $organizationId) {
      id
      availableBalanceInDollar
      balanceInDollars
      name
      account_type
      account_type_string
      payment_system
      payment_system_string
      resource_id
    }
  }
`;


const queryProcessingFeeFinacialAccount = gql`
  query processingFeeFinancialAccount($organizationId: UUID!) {
    processingFeeFinancialAccount(organizationId: $organizationId) {
      id
      availableBalanceInDollar
      balanceInDollars
      name
      account_type
      account_type_string
      payment_system
      payment_system_string
      resource_id
    }
  }
`;




const mutationLegalEntityPayout = gql`
  mutation legalEntityPayout($organizationId: UUID!, $legalEntityId: UUID!, $sourceFinancialAccountId: UUID!, $destinationFinancialAccountId: UUID!, $amountInCents: Long!) {
    legalEntityPayout(organizationId: $organizationId, legalEntityId: $legalEntityId, sourceFinancialAccountId: $sourceFinancialAccountId, destinationFinancialAccountId: $destinationFinancialAccountId, amountInCents: $amountInCents) {
      transfer_id
      status
      status_text
      payment_reason
      payment_reason_text
        
      comment
      application_id
      amount_total_dollars
      amount_requested_dollars
      amount_processing_fee_dollars
      amount_platform_fee_dollars
      created_ts
    }
  }
`;
 



const queryTenantRefundSourceFinacialAccounts = gql`
  query tenantRefundApplicationSourceFinancialAccounts($organizationId: UUID!, $applicationId: UUID!) {
    tenantRefundApplicationSourceFinancialAccounts(organizationId: $organizationId, applicationId: $applicationId) {
      id
      availableBalanceInDollar
      balanceInDollars
      name
      account_type
      account_type_string
      payment_system
      payment_system_string
      resource
      resource_id
    }
  }
`;





export interface TenantRefundRequest {
  organizationId: string;
  accountId: string;
  sourceFinancialAccountId: string;
  destinationFinancialAccountId: string;
  amountInCents: number;
}

const mutationTenantRefund = gql`
  mutation tenantRefund($organizationId: UUID!,  $accountId: UUID!, $sourceFinancialAccountId: UUID!, $destinationFinancialAccountId: UUID!, $amountInCents: Long!) {
    tenantRefund(organizationId: $organizationId, sourceFinancialAccountId: $sourceFinancialAccountId, accountId: $accountId, destinationFinancialAccountId: $destinationFinancialAccountId, amountInCents: $amountInCents) {
      transfer_id
      status
      status_text
      payment_reason
      payment_reason_text
        
      comment
      application_id
      amount_total_dollars
      amount_requested_dollars
      amount_processing_fee_dollars
      amount_platform_fee_dollars
      created_ts
    }
  }
`;
 



const queryDisputedTransfers = gql`
  query disputedTransfers($organizationId: UUID!) {
    disputedTransfers(organizationId: $organizationId) {
      id
      organization_id
      amount
      due_date
      is_complete
      transfer_id
      zum_status
      status_text
      status_id
      type_text
      type_id
      transfer {
        application_id_friendly
      }
    }
  }
`;




const queryDisputedTransfersCount = gql`
  query disputedTransfersCount($organizationId: UUID!) {
    disputedTransfersCount(organizationId: $organizationId) 
  }
`;




const queryTransferSteps = gql`
  query transferSteps($organizationId: UUID!, $transferId: UUID!) {
    transferSteps(organizationId: $organizationId, transferId: $transferId) {
      transfer_id
      step_id
      status
      comment
      amount_in_dollars
      destination_payment_account{
        name
      }
      source_payment_account{
        name
      }
    }
  }
`;


const queryTenantTransfers = gql`
  query tenantTransfers($organizationId: UUID!, $accountId: UUID!) {
    tenantTransfers(organizationId: $organizationId, accountId: $accountId) {
      transfer_id
      status
      payment_reason
      status_text
    
      comment
      application_id
      application_id_friendly
      initiated_by
      amount_total_dollars
      amount_requested_dollars
      amount_processing_fee_dollars
      amount_platform_fee_dollars
      created_ts
     
    }
  }
`;


const queryStripeCreditCardIntent = gql`
  query stripeCreditCardIntent($organizationId: UUID!, $accountId: UUID!) { 
    stripeCreditCardIntent(organizationId: $organizationId, accountId: $accountId) 
 }
`;

const queryActiveDisputeCount = gql`
  query activeDisputeCount($organizationId: UUID!) { 
    activeDisputeCount(organizationId: $organizationId) 
 }
`;




const mutationOrganizationPayPlatform = gql`
  mutation organizationPayPlatform($organizationId: UUID!, $amountInCents: Long) { 
    organizationPayPlatform(organizationId: $organizationId, amountInCents: $amountInCents) {
     transfer_id
      status
      payment_reason
      status_text
    
      comment
      application_id
      application_id_friendly
      initiated_by
      amount_total_dollars
      amount_requested_dollars
      amount_processing_fee_dollars
      amount_platform_fee_dollars
      created_ts
      }
 }
`;



export interface PaymentTransfer {
  transfer_id: string;
  status: string;
  payment_reason: string;
  status_text: string;

  comment: string;
  application_id: string;
  application_id_friendly: string;
  initiated_by: string;
  amount_total_dollars: number;
  amount_requested_dollars: number;
  amount_processing_fee_dollars: number;
  amount_platform_fee_dollars: number;
  created_ts: string;
}



export function usePaymentActions() {
  const state = PmStore();
   
  const [apiFinacialAccount] = useLazyQuery(queryFinancialAccount);
  const [apiTenantFinacialAccounts] = useLazyQuery(queryTenantFinacialAccounts);
  const [apiPaymentConfig] = useLazyQuery(queryPaymentConfig);
  const [apiTenantFinacialAccount] = useLazyQuery(queryTenantFinacialAccount);
  const [apiFinancialAccountTransactions] = useLazyQuery(queryFinancialAccountTransactions);
  const [apiApplicationFinacialAccount] = useLazyQuery(queryApplicationFinacialAccount);
  const [apiApplicationTransfers] = useLazyQuery(queryApplicationTransfers);
  const [apiTransfersInProgress] = useLazyQuery(queryTransfersInProgress);
  const [apiOrganizationFinacialAccounts] = useLazyQuery(queryOrganizationFinacialAccounts);
  const [apiLegalEntityVirtualOpsFinacialAccount] = useLazyQuery(queryLegalEntityVirtualOpsFinacialAccount);
  const [apiLegalEntityVirtualDepositFinacialAccount] = useLazyQuery(queryLegalEntityVirtualDepositFinacialAccount);
  const [apiLegalEntityFinacialAccounts] = useLazyQuery(queryLegalEntityFinacialAccounts);
  const [apiPlatformFeeFinacialAccount] = useLazyQuery(queryPlatformFeeFinacialAccount);
  const [apiProcessingFeeFinacialAccount] = useLazyQuery(queryProcessingFeeFinacialAccount);
  const [apiLegalEntityVirtualSalesTaxFinacialAccount] = useLazyQuery(queryLegalEntityVirtualSalesTaxFinacialAccount);
  const [apiLegalEntityPayout] = useMutation(mutationLegalEntityPayout);
  const [apiTenantRefund] = useMutation(mutationTenantRefund);
  const [apiDisputedTransfers] = useLazyQuery(queryDisputedTransfers);
  const [apiDisputedTransfersCount] = useLazyQuery(queryDisputedTransfersCount);
  const [apiTransferSteps] = useLazyQuery(queryTransferSteps);
  const [apiTenantTransfers] = useLazyQuery(queryTenantTransfers);
  const [apiStripeCreditCardIntent] = useLazyQuery(queryStripeCreditCardIntent);
  const [apiTenantRefundSourceFinacialAccounts] = useLazyQuery(queryTenantRefundSourceFinacialAccounts);
  const [apiActiveDisputeCount] = useLazyQuery(queryActiveDisputeCount);

  const [apiOrganizationPayPlatform] = useMutation(mutationOrganizationPayPlatform);

  



  async function OrganizationPayPlatform(amountInCents: Number): Promise<PaymentTransfer> {
    let organizationId = state?.selectedOrganization?.id;
    try {
      let result = await apiOrganizationPayPlatform({variables: {organizationId, amountInCents}}) as any;
      return result.data.organizationPayPlatform as PaymentTransfer;
    }
    catch(err) {
      toast.error("Api Error, unable to start a payment.");
    }
  }



  async function GetActiveDisputeCount(): Promise<number> {
    let organizationId = state?.selectedOrganization?.id;
    try {
      let result = await apiActiveDisputeCount({variables: {organizationId}}) as any;
      return result.data.activeDisputeCount as number;
    }
    catch(err) {
      toast.error("Api Error, unable to get active dispute count");
    }
  }

  

  async function GetTenantRefundSourceFinacialAccounts(applicationId: string) {
    let organizationId = state?.selectedOrganization?.id;
    try {
      let result = await apiTenantRefundSourceFinacialAccounts({variables: {organizationId, applicationId}}) as any;
      return result.data.tenantRefundApplicationSourceFinancialAccounts as [];
    }
    catch(err) {
      toast.error("Api Error, unable to get refund financial accounts");
    }
  }



  async function GetStripeCreditCardIntent(accountId: string) {
    let organizationId = state?.selectedOrganization?.id;
    try {
      let result = await apiStripeCreditCardIntent({variables: {organizationId, accountId}}) as any;
      return result.data.stripeCreditCardIntent as string;
    }
    catch(err) {
      toast.error("Api Error, Unable to get account stripe credit card intent");
    }
  }

  


  async function GetTenantTransfers(accountId: string) {
    let organizationId = state?.selectedOrganization?.id;
    try {
      let result = await apiTenantTransfers({variables: {organizationId, accountId}}) as any;
      return result.data.tenantTransfers as [];
    }
    catch(err) {
      toast.error("Api Error, Unable to get tenant payment transfers");
    }
  }


  
  async function GetTransferSteps(transferId: string) {
    let organizationId = state?.selectedOrganization?.id;
    try {
      let result = await apiTransferSteps({variables: {organizationId, transferId}}) as any;
      return result.data.transferSteps as [];
    }
    catch(err) {
      console.log(err)
      toast.error("Api Error, Unable to get payment steps");
    }
  }



  async function GetDisputedTransfersCount() {
    let organizationId = state?.selectedOrganization?.id;
    try {
      let result = await apiDisputedTransfersCount({variables: {organizationId}}) as any;
      return result.data.disputedTransfersCount;
    }
    catch(err) {
      toast.error("Api Error, Unable to get payment dispute coute");
    }
  }


  async function GetDisputedTransfers() {
    let organizationId = state?.selectedOrganization?.id;
    try {
      let result = await apiDisputedTransfers({variables: {organizationId}}) as any;
      return result.data.disputedTransfers;
    }
    catch(err) {
      toast.error("Api Error, Unable to get disputes");
    }
  }

  


  async function TenantRefund(params: TenantRefundRequest) {
    var variables: TenantRefundRequest = {
      ...params,
      organizationId: state?.selectedOrganization?.id as string
    };

    try {
      let result = await apiTenantRefund({ variables}) as any;
      return result.data.applicationTenantPayout as {};
    }
    catch (err) {
      toast.error("Api Error, Unable to remove asset contract template");
    }
  }






  function LegalEntityPayout(legalEntityId: string, sourceFinancialAccountId: string, destinationFinancialAccountId: string, amountInCents: number) {
    let organizationId = state?.selectedOrganization?.id;

    return new Promise(async (resolve, reject) => {
      apiLegalEntityPayout({variables: {organizationId, legalEntityId, sourceFinancialAccountId, destinationFinancialAccountId, amountInCents}})
          .then((result: any) => result?.data?.legalEntityPayout)
          .then((result) => resolve(result))
          .catch((err) => {
              toast.error("Api Error, Unable to start legal entity payout");
              reject(err);
          })
      })
  }


  

  function GetProcessingFeeFinacialAccount() {
    let organizationId = state?.selectedOrganization?.id;

    return new Promise(async (resolve, reject) => {
      apiProcessingFeeFinacialAccount({variables: {organizationId}})
          .then((result: any) => result?.data?.processingFeeFinancialAccount)
          .then((result) => resolve(result))
          .catch((err) => {
              toast.error("Api Error, Unable to get platform fee financial accounts");
              reject(err);
          })
      })
  }


  
  function GetPlatformFeeFinacialAccount() {
    let organizationId = state?.selectedOrganization?.id;

    return new Promise(async (resolve, reject) => {
      apiPlatformFeeFinacialAccount({variables: {organizationId}})
          .then((result: any) => result?.data?.platformFeeFinancialAccount)
          .then((result) => resolve(result))
          .catch((err) => {
              toast.error("Api Error, Unable to get platform fee financial accounts");
              reject(err);
          })
      })
  }
  

  function GetLegalEntityFinacialAccounts(legalEntityId: string) {
    let organizationId = state?.selectedOrganization?.id;

    return new Promise(async (resolve, reject) => {
      apiLegalEntityFinacialAccounts({variables: {organizationId, legalEntityId}})
          .then((result: any) => result?.data?.legalEntityFinancialAccounts)
          .then((result) => resolve(result))
          .catch((err) => {
              toast.error("Api Error, Unable to get legal entity financial accounts");
              reject(err);
          })
      })
  }

  



  function GetLegalEntityVirtualSalesTaxFinacialAccount(legalEntityId: string) {
    let organizationId = state?.selectedOrganization?.id;

    return new Promise(async (resolve, reject) => {
      apiLegalEntityVirtualSalesTaxFinacialAccount({variables: {organizationId, legalEntityId}})
          .then((result: any) => result?.data?.legalEntityVirtualSalesTaxFinancialAccount)
          .then((result) => resolve(result))
          .catch((err) => {
              toast.error("Api Error, Unable to get legal entity financial account");
              reject(err);
          })
      })
  }



  function GetLegalEntityVirtualDepositFinacialAccount(legalEntityId: string) {
    let organizationId = state?.selectedOrganization?.id;

    return new Promise(async (resolve, reject) => {
      apiLegalEntityVirtualDepositFinacialAccount({variables: {organizationId, legalEntityId}})
          .then((result: any) => result?.data?.legalEntityVirtualDepositFinancialAccount)
          .then((result) => resolve(result))
          .catch((err) => {
              toast.error("Api Error, Unable to get legal entity financial account");
              reject(err);
          })
      })
  }





  function GetLegalEntityVirtualOpsFinacialAccount(legalEntityId: string) {
    let organizationId = state?.selectedOrganization?.id;

    return new Promise(async (resolve, reject) => {
      apiLegalEntityVirtualOpsFinacialAccount({variables: {organizationId, legalEntityId}})
          .then((result: any) => result?.data?.legalEntityVirtualOperationalFinancialAccount)
          .then((result) => resolve(result))
          .catch((err) => {
              toast.error("Api Error, Unable to get legal entity financial account");
              reject(err);
          })
      })
  }


 
  async function GetOrganizationFinacialsAccounts(): Promise<[]> {
    try {
      let organizationId = state?.selectedOrganization?.id;
      let result = await apiOrganizationFinacialAccounts({ variables: {organizationId}}) as any;
      return result.data.organizationFinancialAccounts as [];
    }
    catch (err) {
      toast.error("Api Error, Unable to get organization financial accounts");
    }
  }






  function GetTransfersInProgress() {
    let organizationId = state?.selectedOrganization?.id;

    return new Promise(async (resolve, reject) => {
      apiTransfersInProgress({variables: {organizationId}})
          .then((result: any) => result?.data?.transfersInProgress)
          .then((result) => resolve(result))
          .catch((err) => {
              toast.error("Api Error, Unable to get application payment transfers");
              reject(err);
          })
      })
  }



  function GetApplicationTransfers(applicationId: string) {
    let organizationId = state?.selectedOrganization?.id;

    return new Promise(async (resolve, reject) => {
      apiApplicationTransfers({variables: {organizationId, applicationId}})
          .then((result: any) => result?.data?.applicationTransfers)
          .then((result) => resolve(result))
          .catch((err) => {
              toast.error("Api Error, Unable to get application payment transfers");
              reject(err);
          })
      })
  }





  function GetApplicationFinancialAccount(applicationId: string) {
    let organizationId = state?.selectedOrganization?.id;

    return new Promise(async (resolve, reject) => {
      apiApplicationFinacialAccount({variables: {organizationId, applicationId}})
          .then((result: any) => result?.data?.applicationFinancialAccount)
          .then((result) => resolve(result))
          .catch((err) => {
              toast.error("Api Error, Unable to get application financial account");
              reject(err);
          })
      })
  }


  
  function GetPaymentConfig() {
    let organizationId = state?.selectedOrganization?.id;

    return new Promise(async (resolve, reject) => {
      apiPaymentConfig({variables: {organizationId}})
          .then((result: any) => result?.data?.paymentConfig)
          .then((result) => resolve(result))
          .catch((err) => {
              toast.error("Api Error, Unable to get payment config");
              reject(err);
          })
      })
  }



  function GetFinancialAccountTransactions(financialAccountId: string, start: Date, end: Date) {
    let organizationId = state?.selectedOrganization?.id;

    return new Promise(async (resolve, reject) => {
      apiFinancialAccountTransactions({variables: {organizationId, financialAccountId, start, end}})
          .then((result: any) => result?.data?.financialAccountTransactions)
          .then((result) => resolve(result))
          .catch((err) => {
              toast.error("Api Error, Unable to get tenant financial account transactions");
              reject(err);
          })
      })
  }


  function GetTenantFinacialAccounts(accountId: string) {
    let organizationId = state?.selectedOrganization?.id;

    return new Promise(async (resolve, reject) => {
      apiTenantFinacialAccounts({variables: {organizationId, accountId}})
          .then((result: any) => result?.data?.tenantFinancialAccounts)
          .then((result) => resolve(result))
          .catch((err) => {
              toast.error("Api Error, Unable to get tenant financial account");
              reject(err);
          })
      })
  }

  function GetTenantFinacialAccount(accountId: string) {
    let organizationId = state?.selectedOrganization?.id;

    return new Promise(async (resolve, reject) => {
        apiTenantFinacialAccount({variables: {organizationId, accountId}})
          .then((result: any) => result?.data?.tenantFinancialAccount)
          .then((result) => resolve(result))
          .catch((err) => {
              toast.error("Api Error, Unable to get tenant financial account");
              reject(err);
          })
      })
  }
  function GetFinacialAccount(financialAccountId: string) {
    let organizationId = state?.selectedOrganization?.id;

    return new Promise(async (resolve, reject) => {
      apiFinacialAccount({variables: {organizationId, financialAccountId}})
          .then((result: any) => result?.data?.financialAccount)
          .then((result) => resolve(result))
          .catch((err) => {
              toast.error("Api Error, Unable to get financial account");
              reject(err);
          })
      })
  }
   

    
    return {
      GetTenantFinacialAccount,
      GetFinacialAccount,
      GetFinancialAccountTransactions,
      GetTenantFinacialAccounts,
      GetPaymentConfig,
      GetApplicationFinancialAccount,
      GetApplicationTransfers,
      GetTransfersInProgress,
      GetLegalEntityVirtualOpsFinacialAccount,
      GetLegalEntityVirtualDepositFinacialAccount,
      GetLegalEntityFinacialAccounts,
      GetPlatformFeeFinacialAccount,
      GetProcessingFeeFinacialAccount,
      GetLegalEntityVirtualSalesTaxFinacialAccount,
      LegalEntityPayout,
      TenantRefund,
      GetDisputedTransfers,
      GetDisputedTransfersCount,
      GetTransferSteps,
      GetTenantTransfers,
      GetStripeCreditCardIntent,
      GetTenantRefundSourceFinacialAccounts,
      GetOrganizationFinacialsAccounts,
      GetActiveDisputeCount,
      OrganizationPayPlatform
    };
}




